import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';

const tcpLabel = (globalGenericLabelsObj) =>
  renderLabel(globalGenericLabelsObj?.lbl_tcp, 'lbl_tcp');
const gymLabel = (globalGenericLabelsObj) =>
  renderLabel(globalGenericLabelsObj?.lbl_gym, 'lbl_gym');
const snjLabel = (globalGenericLabelsObj) =>
  renderLabel(globalGenericLabelsObj?.lbl_snj, 'lbl_snj');
const pjpLabel = (globalGenericLabelsObj) =>
  renderLabel(globalGenericLabelsObj?.lbl_pjp, 'lbl_pjp');

const getPdpBrandLabel = ({ primaryBrand, alternateBrand, prodBrand, getBrand = false }) => {
  const globalGenericLabelsObj = getLabelFromCopyOrFromTranslation(
    GLOBAL_GENERIC_LABELS,
    GlobalGenericLabels
  );
  if ((primaryBrand || alternateBrand || prodBrand) === 'SNJ') {
    return getBrand ? 'SNJ' : snjLabel(globalGenericLabelsObj);
  }

  if ((primaryBrand || alternateBrand || prodBrand) === 'GYM') {
    return getBrand ? 'GYM' : gymLabel(globalGenericLabelsObj);
  }
  if ((primaryBrand || alternateBrand || prodBrand) === 'PJP') {
    return getBrand ? 'PJP' : pjpLabel(globalGenericLabelsObj);
  }

  return getBrand ? 'TCP' : tcpLabel(globalGenericLabelsObj);
};

export default getPdpBrandLabel;
